module.exports = __webpack_public_path__ + "static/media/vtex41.776811ee.png";